<template>
  <v-layout justify-center>
    <v-flex>
      <panel :title="$t('groupDetails.createGroup')">
        <v-text-field
          :label="$t('groupGenerics.groupName')"
          required
          :rules="[required]"
          v-model="group.group_name"
        ></v-text-field>
        <v-text-field
          :label="$t('groupGenerics.groupDesc')"
          required
          :rules="[required]"
          v-model="group.description"
        ></v-text-field>
        <div class="danger-alert" v-if="error">
          {{error}}
        </div>
        <v-btn
          dark
          class="secondary"
          @click="create">
          {{$t('groupDetails.createGroup')}}
        </v-btn>
      </panel>
    </v-flex>
  </v-layout>
</template>

<script>
import GroupsApi from '@/api/groups-api'

export default {
  data () {
    return {
      group: {
        group_name: null,
        description: null
      },
      error: null,
      required: (value) => !!value || 'Required.'
    }
  },
  methods: {
    async create () {
      this.error = null
      const areAllFieldsFilledIn = Object
        .keys(this.group)
        .every(key => !!this.group[key])

      if (!areAllFieldsFilledIn) {
        this.error = this.$t('mainErrors.fieldsRequired')
        return
      }
      
      GroupsApi.post(this.group).then((resp) => {
        if(resp.status !== 200) {
          this.error = this.$t('mainErrors.somethingWrong')
          return
        }

        // close the modal
        this.$emit('close');
      }).catch(err => {
        this.error = this.$t('mainErrors.somethingWrong')
        console.error(err)
      })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/CreateGroup.vue